import { Deserializable } from "../shared/Deserializable";

export class Documento implements Deserializable {

  numero?: string;
  tipo?: string;
  version?: string;

  // constructor(numero: string, tipo ?: string, version ?:string) {
  //     this.numero = numero;
  //     if(tipo)
  //         this.tipo = tipo
  //     if(version)
  //         this.version = version
  // }

  constructor() {
    // This is intentional
  }

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}